// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-7b87923e] .vs-popup {\n  width: 300px !important;\n  height: 400px !important;\n}\n[data-v-7b87923e] .vs-popup--content {\n  overflow: unset !important;\n}", ""]);
// Exports
module.exports = exports;
